// The backend applies a safe default of true for existing accounts and explicitly writes false for new ones.
export function canShowOnboarding({ onboardingCompleted }) {
  return onboardingCompleted === false;
}
